module.exports = __webpack_public_path__ + "static/media/Car_calligraphy_main_t.18fc7f1b.jpg";